/**
 * The values the web page and the native screen both depend on.
 *
 * Test IDs live here because a diverged one fails silently: each platform's
 * suite keeps passing against its own copy while the two stop describing the
 * same element. Dimensions are stored unitless so each platform can format them
 * the way its style system expects without the numbers drifting apart.
 */

export const LOADING_TEST_ID = 'intro-video-loading';
export const UPLOAD_PROGRESS_TEST_ID = 'intro-video-upload-progress';
export const UPLOADED_VIDEO_TEST_ID = 'intro-video-player';

export const THUMBNAIL_WIDTH_PX = 68;
export const THUMBNAIL_HEIGHT_PX = 110;
export const PLAY_BADGE_SIZE_PX = 28;
export const SPINNER_DIAMETER_PX = 40;
export const PROGRESS_BAR_HEIGHT_PX = 10;
export const UPLOADED_VIDEO_LOADING_HEIGHT_PX = 320;

/** The letterbox both platforms frame the player in */
export const UPLOADED_VIDEO_ASPECT_RATIO = 16 / 10;

/** The surface that sent the sitter to the manage screen, stamped on every upload event */
export const IntroVideoEntrypoint = {
  ProfilePrompt: 'profile_prompt',
  DashboardCard: 'dashboard_card',
  ServiceManagement: 'service_management',
  Ssu: 'ssu',
  /** The screen was opened with no recognized entrypoint, e.g. from a bare link */
  Deeplink: 'deeplink',
} as const;

export type IntroVideoEntrypointValue =
  (typeof IntroVideoEntrypoint)[keyof typeof IntroVideoEntrypoint];

const ENTRYPOINTS: readonly string[] = Object.values(IntroVideoEntrypoint);

/** Reads the `entrypoint` a route carried, which arrives untyped from a URL or native props. */
export const toIntroVideoEntrypoint = (value: unknown): IntroVideoEntrypointValue =>
  typeof value === 'string' && ENTRYPOINTS.includes(value)
    ? (value as IntroVideoEntrypointValue)
    : IntroVideoEntrypoint.Deeplink;

export const INTRO_VIDEO_MANAGE_PATH = '/provider-profile/intro-video/';

/** The manage screen's web URL, tagged with the surface the sitter arrived from. */
export const introVideoManageUrl = (entrypoint: IntroVideoEntrypointValue): string =>
  `${INTRO_VIDEO_MANAGE_PATH}?entrypoint=${entrypoint}`;
